import styled, { css } from 'styled-components';
import { WrapperDefault } from '../Shared/Shared';
import { FORM_MULTI_TEXT_LAYOUT } from './types';
export const FormMultiTextWrapper = styled(WrapperDefault)``;

export const FormMultiTextInput = styled.input<{ error?: boolean; width?: number; readOnly?: boolean }>`
  width: ${({ width }) => (width ? `${width}px` : '100%')};
  margin-top: 10px;
  margin-bottom: 10px;
  height: 20px;
  font-size: 14px;
  border: none;
  border-bottom: 3px solid var(--primary-gray);
  padding: 20px 0;

  transition: all 150ms ease-in-out;

  &:focus {
    outline: none;
    border-bottom: 3px solid var(--black);
    font-size: 16px;
  }
  &::placeholder {
    color: var(--secondary-gray);
  }

  color: ${({ error }) => (error ? 'var(--error)' : 'var(--black)')};

  ${({ readOnly }) =>
    readOnly &&
    css`
      opacity: 0.8;
      pointer-events: none;
    `}
  background-color:transparent;
  @media (max-width: 1200px) {
    font-family: inherit;
    width: ${({ width }) => (width ? `${width}px` : '100%')};
    font-size: 14px;
  }
`;

export const Terms = styled.div`
  margin-bottom: 29px;
  position: absolute;
  bottom: 0;
  span {
    font-size: 14px;
    color: var(--text-primary);
    a {
      color: var(--text-primary);
      text-decoration: underline;
    }
  }
`;

export const FormMultiTextContainer = styled.div<{ layout: FORM_MULTI_TEXT_LAYOUT }>`
  display: flex;
  flex-direction: ${({ layout }) => (layout === FORM_MULTI_TEXT_LAYOUT.COLUMN ? 'column' : 'row')};
  gap: 4px;
  margin-top: 20px;
  margin-bottom: 0;
`;
